//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'd2-export-table',
  data: function data() {
    return {
      drawer: {
        visible: false
      }
    };
  },
  methods: {
    onTriggerClick: function onTriggerClick() {
      this.drawerOpen();
    },
    drawerOpen: function drawerOpen() {
      this.drawer.visible = true;
    }
  }
};